export default __webpack_public_path__ + "static/media/cms-logo.5ef9b34f.png";